import React, { useContext } from 'react';

import GlobalContext from 'GlobalContext';

import Text from 'components/shared/text';
import Card from 'components/new-card/Card';
import Button from 'components/shared/button';
import TextBanner from 'components/shared/text-banner';

import IconWithEffect from './IconWithEffect';

import './AboutPage.scss';

const email = 'info@castlecraftstudios.com';

const AboutView = () => {
  const {
    setShowNotification,
    setNotificationText,
    setNotificationStatus,
  } = useContext(GlobalContext);

  const copy = async (textToCopy) => await navigator.clipboard.writeText(textToCopy);

  const handleCopy = () => {
    copy(email);
    setNotificationText('Email copied to clipboard!');
    setNotificationStatus('success');
    setShowNotification(true);
  };

  return (
    <section className='about-page'>
      <Card headerText="About">
        <div className="about-container">
          <IconWithEffect />
          <Text text="A fresh take on learning" margin="20px 0" />
          <TextBanner bannerText="web development" />
          <p className="contact-us-text">
            Our site is a <span className="contact-us-text-accent">free</span> and{' '}
            <span className="contact-us-text-accent">easy</span> way to quickly
            save code snippets and other resources!
          </p>
          <Text
            width="85%"
            lineHeight="1.5"
            textAlign="left"
            margin="20px auto 40px auto"
            text="Below is our support email, click it to quickly copy it!"
          />
          <Button buttonText={email} handleClick={handleCopy} />
          <p className='copyright-statement'>TechTutz is owned and operated exclusively by castlecraftstudios.com</p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="castlecraft-link"
            href="https://www.castlecraftstudios.com"
          >
            Visit CastleCraftStudios
          </a>
        </div>
      </Card>
    </section>
  );
};

export default AboutView;
